var SupportChatSuccessView, SupportFlexibleContactChannelModel, SupportHorizontalViewManagerBase, SupportIntermediateView, SupportLiveChatModel, SupportLiveChatView, SupportOrderModel, SupportOrdersCollection, SupportProblemSolvedView, SupportTicketSuccessView;

SupportIntermediateView = require('../views/intermediate_view');

SupportFlexibleContactChannelModel = require('../models/flexible_contact_channels');

SupportLiveChatModel = require('../models/live_chat');

SupportLiveChatView = require('../views/live_chat_view');

SupportOrdersCollection = require('../collections/orders');

SupportOrderModel = require('../models/order');

SupportTicketSuccessView = require('../views/ticket_success_view');

SupportProblemSolvedView = require('../views/problem_solved_view');

SupportChatSuccessView = require('../views/chat_success_view');

SupportHorizontalViewManagerBase = (function() {
  function SupportHorizontalViewManagerBase() {
    this.configureContentModel();
    this.configureOptimizedContactChannelsModel();
    this.configureFlexibleContentChannelsModel();
    this.initLiveChat();
    Groupon.Support.OrdersCollection = new SupportOrdersCollection();
    Groupon.Support.currentOrdersFilter = Groupon.Support.OrdersCollection.createPurchaseDateDescendingFilter();
    Groupon.Support.OrderModel = new SupportOrderModel();
  }

  SupportHorizontalViewManagerBase.prototype.show = function(view, params) {
    this.setCurrentView(view);
    Groupon.Support.CURRENTVIEW.render(params);
    $('#help-wizard').html(Groupon.Support.CURRENTVIEW.el);
    toggleCallUs(Groupon.Support.CURRENTVIEW.id);
    return $(window).scrollTop(0);
  };

  SupportHorizontalViewManagerBase.prototype.removeElement = function(view) {
    return view.remove();
  };

  SupportHorizontalViewManagerBase.prototype.setCurrentView = function(view) {
    if (Groupon.Support.CURRENTVIEW != null) {
      this.removeElement(Groupon.Support.CURRENTVIEW);
    }
    return Groupon.Support.CURRENTVIEW = view;
  };

  SupportHorizontalViewManagerBase.prototype.render = function() {};

  SupportHorizontalViewManagerBase.prototype.renderIntermediateView = function() {
    var intermediateView;
    if ($('#intermediate_page').length > 0) {
      return intermediateView = new SupportIntermediateView({
        el: $('#intermediate_page')
      });
    } else {
      intermediateView = new SupportIntermediateView();
      intermediateView.render();
      return $("#intermediate-page-container").html(intermediateView.el);
    }
  };

  SupportHorizontalViewManagerBase.prototype.renderOrders = function() {
    var stepOneView;
    stepOneView = this.getStepOneView();
    return this.show(stepOneView);
  };

  SupportHorizontalViewManagerBase.prototype.renderOrderDetails = function(order) {
    var stepOneView;
    stepOneView = this.getStepOneView();
    return this.show(stepOneView, {
      order: order
    });
  };

  SupportHorizontalViewManagerBase.prototype.renderDropDowns = function() {
    var stepTwoView;
    stepTwoView = this.getStepTwoView();
    return this.show(stepTwoView);
  };

  SupportHorizontalViewManagerBase.prototype.renderContactChannels = function() {
    var stepThreeView;
    stepThreeView = this.getStepThreeView();
    this.show(stepThreeView);
    stepThreeView.postRenderhandler();
    return stepThreeView;
  };

  SupportHorizontalViewManagerBase.prototype.ticketSuccess = function() {
    return this.show(new SupportTicketSuccessView);
  };

  SupportHorizontalViewManagerBase.prototype.chatSuccess = function() {
    return this.show(new SupportChatSuccessView);
  };

  SupportHorizontalViewManagerBase.prototype.renderProblemSolved = function() {
    return this.show(new SupportProblemSolvedView);
  };

  SupportHorizontalViewManagerBase.prototype.getStepOneView = function() {};

  SupportHorizontalViewManagerBase.prototype.getStepTwoView = function() {};

  SupportHorizontalViewManagerBase.prototype.getStepThreeView = function() {};

  SupportHorizontalViewManagerBase.prototype.configureContentModel = function() {};

  SupportHorizontalViewManagerBase.prototype.configureOptimizedContactChannelsModel = function() {};

  SupportHorizontalViewManagerBase.prototype.renderUserSignIn = function(options) {};

  SupportHorizontalViewManagerBase.prototype.configureFlexibleContentChannelsModel = function() {
    return Groupon.Support.FlexibleContactChannelModel = new SupportFlexibleContactChannelModel;
  };

  SupportHorizontalViewManagerBase.prototype.initLiveChat = function() {
    Groupon.Support.LiveChatModel = new SupportLiveChatModel();
    return Groupon.Support.LiveChatView = new SupportLiveChatView({
      model: Groupon.Support.LiveChatModel
    });
  };

  return SupportHorizontalViewManagerBase;

})();

module.exports = SupportHorizontalViewManagerBase;

//# sourceMappingURL=data:application/json;base64,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
